import { useDisclosure, useHotkey } from "@msuite/ui/hooks";
import { InsightsSpotlightTrigger } from "./insights-spotlight-trigger";
import { Fragment } from "react";
import { InsightsSpotlight } from "./insights-spotlight";
import { AnimatePresence } from "motion/react";

export function Insights() {
	const disclosure = useDisclosure();

	useHotkey("Esc", disclosure.onClose);

	/** Render */
	return (
		<Fragment>
			<InsightsSpotlightTrigger disclosure={disclosure} />
			<AnimatePresence mode="wait">
				{disclosure.isOpen && (
					<InsightsSpotlight
						isOpen={disclosure.isOpen}
						onClose={disclosure.onClose}
					/>
				)}
			</AnimatePresence>
		</Fragment>
	);
}
